<div *ngIf="_item.oldVal === undefined" class="ddc-cich-scalar-item">
  <span ddcLabel labelKey="{{_item.labelKey}}"></span> : <span class="ddc-cich-newVal">{{_item.newVal}}</span>
</div>
<div *ngIf="_item.oldVal !== undefined" class="ddc-cich-scalar-item">
  <span ddcLabel labelKey="{{_item.labelKey}}"></span> : <span class="ddc-cich-oldVal">{{_item.oldVal}}</span>
  <i class="material-icons small">redo</i>
  <span class="ddc-cich-newVal">{{_item.newVal}}</span>
</div>
